import { makeDocumentAPIs } from '../../modules/documentAPIFactory'
import { getOpportunityDocumentListData } from './mockData'
import type { IOpportunityDocument } from '~/types/document/models'

export const {
  getDocuments: getOpportunityDocuments,
  postDocument: postOpportunityDocument,
  patchDocument: patchOpportunityDocument,
  deleteDocument: deleteOpportunityDocument,
  handlers,
} = makeDocumentAPIs<IOpportunityDocument>({
  apiPathEntityNamePrefix: 'opportunity',
  getDocumentListDataFn: getOpportunityDocumentListData,
})
